import { Component, OnInit, ViewChild } from "@angular/core";
import { Router } from "@angular/router";
import { NocDashboardModel } from "src/app/model/NocDashboardModel";
import { HomeService } from "src/app/services/home.service";
import { GoogleChartComponent, ChartType } from "angular-google-charts";
import { MasterService } from "src/app/services/master.service";
import { MatSnackBar } from "@angular/material/snack-bar";

@Component({
  selector: "app-secure-noc-dashboard",
  templateUrl: "./noc-dashboard.component.html",
  styleUrls: ["./noc-dashboard.component.scss"],
})
export class NocDashboardComponent implements OnInit {
  nocDashboardModel: NocDashboardModel;
  loaded: boolean = false;
  date: Date;
  @ViewChild("googlechart")
  googlechart: GoogleChartComponent;
  public chart = {
    title: "Hello",
    type: ChartType.Gauge,
    data: [],
    options: {
      width: 1200,
      height: 200,
      greenFrom: 40,
      greenTo: 400,
      redFrom: 0,
      redTo: 20,
      yellowFrom: 20,
      yellowTo: 40,
      minorTicks: 5,
    },
  };
  constructor(
    private router: Router,
    private homeService: HomeService,
    private masterService: MasterService,
    private _snackBar: MatSnackBar
  ) {}

  ngOnInit(): void {
    this.loaded = false;
    this.homeService.fetchNOCDashboard().subscribe(
      (dashboard) => {
        this.chart.data = [
          ["SMS", dashboard.smsSuccessPerHour],
          ["EMAIL", dashboard.emailSuccessPerHour],
          ["Digilocker", dashboard.digiPerHour],
          ["Esign", dashboard.esignPerHour],
          ["Application", dashboard.applicationsPerHour],
          ["Payment", dashboard.paymentsPerHour],
          ["PAN", dashboard.panPerHour],
          ["Domicile", dashboard.domicilePerHour],
          ["Income", dashboard.incomeCertificatePerHour],
          ["Caste", dashboard.ccPerHour],
        ];
        this.nocDashboardModel = dashboard;
        this.loaded = true;
        this.date = new Date();
      },
      (error) => {
        //this.loaded = true;
      }
    );
  }

  async successToast() {
    await this._snackBar.open("Push to Moderation Job.", "Close", {
      horizontalPosition: "right",
      verticalPosition: "top",
      panelClass: "success-toast",
      duration: 3 * 1000,
    });
  }

  async warningToast() {
    await this._snackBar.open("Please Upload Logo", "Close", {
      horizontalPosition: "right",
      verticalPosition: "top",
      panelClass: "warning-toast",
      duration: 3 * 1000,
    });
  }

  async errorToast(errorMessage: string, dur?: number) {
    await this._snackBar.open(errorMessage, "Close", {
      horizontalPosition: "right",
      verticalPosition: "top",
      panelClass: "error-toast",
      duration: dur ? dur : 3 * 1000,
    });
  }

  bulkPushToModerationJob() {
    console.log("Button Call");

    this.masterService.generateBulkPushToModerationJob().subscribe(
      (data) => {
        if (data.status === "SUCCESS") {
          this.masterService.successToast(
            " Job for Bulk Push To Moderation Started."
          );
        } else {
          this.errorToast(data.errorMessage);
        }
      },
      (error) => {
        this.errorToast(
          error?.error?.message ||
            error?.errorMessage ||
            error?.error?.errorMessage
        );
      }
    );
  }

  refresh() {
    this.ngOnInit();
  }

  domicileModrationJob() {
    this.masterService.generateDomicileModerationJob().subscribe(
      (data) => {
        if (data.status === "SUCCESS") {
          this.masterService.successToast(
            " Job for Domicile Moderation Started."
          );
        } else {
          this.errorToast(data.errorMessage);
        }
      },
      (error) => {
        this.errorToast(
          error?.error?.message ||
            error?.errorMessage ||
            error?.error?.errorMessage
        );
      }
    );
  }
  settlementPaymentJob() {
    this.masterService.generateSettlementPaymentJob().subscribe(
      (data) => {
        if (data.status === "SUCCESS") {
          this.masterService.successToast(
            " Job for Settlement Payment Started."
          );
        } else {
          this.errorToast(data.errorMessage);
        }
      },
      (error) => {
        this.errorToast(
          error?.error?.message ||
            error?.errorMessage ||
            error?.error?.errorMessage
        );
      }
    );
  }
}
